import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["fill"];
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.857 11.529c.26-.26.682-.26.942 0l2.194 2.195 2.194-2.195a.666.666 0 1 1 .943.943l-2.665 2.666a.666.666 0 0 1-.943 0l-2.665-2.666a.667.667 0 0 1 0-.943"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.994 8c.368 0 .666.298.666.667v6a.666.666 0 1 1-1.333 0v-6c0-.369.299-.667.667-.667"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M.671 5.219A5.996 5.996 0 0 1 11.645 6h.346a3.999 3.999 0 0 1 2.303 7.272.666.666 0 1 1-.767-1.09 2.667 2.667 0 0 0-1.535-4.849h-.84a.666.666 0 0 1-.646-.5 4.665 4.665 0 1 0-8.01 4.252.667.667 0 0 1-.998.884 6 6 0 0 1-.827-6.75"
}, null, -1);
const _hoisted_6 = [_hoisted_3, _hoisted_4, _hoisted_5];
const _hoisted_7 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "a"
}, [/*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("g", {
    "clip-path": "url(#a)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    fill: $props.color
  }, _hoisted_6, 8, _hoisted_2), _hoisted_7], 8, _hoisted_1);
}